import { render, staticRenderFns } from "./PageMealPlanDays.vue?vue&type=template&id=dabb25ec"
import script from "./PageMealPlanDays.vue?vue&type=script&lang=js"
export * from "./PageMealPlanDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports